import React from "react"

const SiteTitle = (props) => {
    return (<h3 className={`${props.color ? props.color : 'text-yellow'} uppercase xl:text-5xl leading-relaxed lg:text-4xl text-3xl mb-2 font-raleway font-bold`}>{props.title}</h3>)
}

export default SiteTitle;
